<router-outlet></router-outlet>
<app-loading-bar></app-loading-bar>